import YouTubePlayer from 'youtube-player';
import idMixin from '@/mixins/aha-id';

export default {
    mixins: [idMixin],
    render(h) {
        const youtubeContainerId = this.safeId('_AHA_youtube_');

        const youtube = h(
            'div', {
                class: 'youtube-player',
                attrs: {
                    id: youtubeContainerId
                }
            }
        );

        const embed = h(
            'div', {
                class: 'embed-responsive embed-responsive-16by9'
            }, [youtube]
        );

        const closeButton = h(
            'b-btn-close', {
                on: {
                    click: (event) => {
                        this.$root.$emit('bv::hide::modal', this.trigger, event.target);
                    }
                }
            }
        );

        const modal = h(
            'aha-modal', {
                class: 'c-modal--youtube',
                attrs: {
                    id: this.trigger,
                    centered: true,
                    lazy: true,
                    hideFooter: true,
                    hideHeader: true,
                    noFade: true,
                    title: this.title
                },
                on: {
                    shown: (event) => {
                        const arg = event.arg;
                        const player = YouTubePlayer(youtubeContainerId, {
                            playerVars: {
                                rel: 0
                            }
                        });

                        // eslint-disable-next-line
                        if(arg === 'queue') {
                            player.cueVideoById(this.videoId);
                        } else {
                            player.loadVideoById(this.videoId);
                            player.playVideo();
                        }
                    }
                }
            }, [closeButton, embed]
        );

        return modal;
    },
    props: {
        trigger: {
            type: String,
            required: true
        },
        title: {
            type: String,
            default: 'Video'
        },
        videoId: {
            type: String,
            required: true
        }
    }
};



// WEBPACK FOOTER //
// ./src/app/components/aha-youtube.js